import { findCanonicalConversationByPhone } from "../../../messaging/canonicalConversationLookup";
import { fetchCanonicalMessages } from "../../../messaging/canonicalMessagingApi";

// The query photo picker uses the same canonical history and attachment IDs as chat.
export async function fetchCustomerChatImages(phone) {
  if (!String(phone || "").replace(/\D/g, "")) return [];
  const conversation = await findCanonicalConversationByPhone(phone);
  if (!conversation) return [];
  const page = await fetchCanonicalMessages(conversation.id, { limit: 100 });
  return canonicalImageChoices(page.items);
}

export function canonicalImageChoices(items) {
  return items.filter(item => item?.kind === "image" && item.content?.attachment?.id).map(item => ({
    id: item.id,
    attachmentId: item.content.attachment.id,
    fileName: item.content.attachment.file_name || "chat-image.jpg",
    created: item.created_at,
  }));
}
